
import Block from 'Mixins/Block';
import slider from 'Mixins/slider';

export default Block('component-hero', {
	onLoad (qComponent) {

		const slides 		= qComponent.child('.swiper-slide');
		const controller 	= qComponent.child('.component-hero__controller');
		const indication 	= qComponent.child('.component-hero__scroll-indication');
		const hasVideo 		= !!qComponent.child('.component-hero__background video').length;

		if (slides.length > 1) {

			slider.init(this.selector);

			controller.addClass('component-hero__controller--show');

		}

		if (hasVideo) {

			const classNameButton 	= 'component-hero__background-video-controls-pause';
			const classNamePaused 	= 'component-hero__background-video-controls-pause--paused';
			let isPaused 			= false;

			qComponent.addEvent('click', event => {

				if (event.target.classList && event.target.classList.contains(classNameButton)) {

					const button = qComponent.child(`.${classNameButton}`);
					const videos = qComponent.child('.component-hero__background video');

					videos.forEach(video => {

						if (isPaused) {

							video.play();
							button.removeClass(classNamePaused);

						} else {

							video.pause();
							button.addClass(classNamePaused);

						}

					});

					isPaused = !isPaused;

				}

			});

		}

		indication.addEvent('click', event => {

			const scrollToElement = document.querySelector('#global__content');

			if (scrollToElement) {

				event.preventDefault();

				scrollToElement.scrollIntoView({
					behavior: 'smooth'
				});

				scrollToElement.focus();

			}

		});

	}
});
